export var UP = 'up';
export var DOWN = 'down';

// Scroll to selected dropdown menu-item in case the item is not visible due to overflow
export default function scrollItemIntoView(direction, dropDownDOMNode, focusedItemDOMNode) {
  if (!dropDownDOMNode || !focusedItemDOMNode) {
    return;
  }
  var menuHeight = dropDownDOMNode.clientHeight;
  var itemHeight = focusedItemDOMNode.clientHeight;
  var itemOffsetTop = focusedItemDOMNode.offsetTop;
  switch (direction) {
    case UP:
      if (itemOffsetTop < dropDownDOMNode.scrollTop) {
        dropDownDOMNode.scrollTop = dropDownDOMNode.scrollTop - itemHeight;
      }
      break;
    case DOWN:
      if (itemOffsetTop > menuHeight - itemHeight) {
        dropDownDOMNode.scrollTop = dropDownDOMNode.scrollTop + itemHeight;
      }
      break;
    default:
      break;
  }
}